// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2bKzg","content":"styles_content__3jfGH","checkbox":"styles_checkbox__3RC_H","checkboxLabel":"styles_checkboxLabel__1gnzZ"};